import { CardType } from '../store/client/client.types';

const PAYMENT_CARD_URL_MAP = {
  [CardType.Visa]: 'visa.svg',
  [CardType.AmericanExpress]: 'american-express.svg',
  [CardType.Amex]: 'american-express.svg',
  [CardType.Diners]: 'diners-club.svg',
  [CardType.DinersClub]: 'diners-club.svg',
  [CardType.Discover]: 'discover.svg',
  [CardType.JCB]: 'JCB.svg',
  [CardType.MasterCard]: 'master-card-icon.svg',
  [CardType.UnionPay]: 'unionpay.svg',
  [CardType.Unknown]: 'unknown-card.svg',
};

const NORMALIZED_CARD_URL_MAP = Object.entries(PAYMENT_CARD_URL_MAP).reduce((acc, [key, value]) => {
  acc[key.toLowerCase()] = value;
  return acc;
}, {} as Record<string, string>);

const WALLET_ICON = 'wallet.svg';

const WALLET_ICON_MAP: Record<string, string> = {
  apple_pay: 'apple-pay.svg',
  google_pay: 'google-pay.svg',
  link: 'link.svg',
};

export const hasOwnWalletIcon = (walletType?: string | null): boolean => !!walletType && !!WALLET_ICON_MAP[walletType];

export const getBrandIcon = (brand?: CardType | string | null): string => {
  if (!brand || typeof brand !== 'string') {
    return PAYMENT_CARD_URL_MAP[CardType.Unknown];
  }

  const normalizedBrand = brand.toLowerCase();

  return NORMALIZED_CARD_URL_MAP[normalizedBrand] ?? PAYMENT_CARD_URL_MAP[CardType.Unknown];
};

export const getPaymentMethodIcon = (method: {
  brand?: CardType | string | null;
  walletType?: string | null;
}): string => {
  if (method.walletType && WALLET_ICON_MAP[method.walletType]) {
    return WALLET_ICON_MAP[method.walletType];
  }

  const brandIcon = getBrandIcon(method.brand);

  return brandIcon === PAYMENT_CARD_URL_MAP[CardType.Unknown] && method.walletType ? WALLET_ICON : brandIcon;
};

export const getPaymentMethodIcons = (method: {
  brand?: CardType | string | null;
  walletType?: string | null;
}): string[] => {
  const walletIcon = method.walletType ? WALLET_ICON_MAP[method.walletType] : undefined;
  const brandIcon = getBrandIcon(method.brand);
  const brandIsUnknown = brandIcon === PAYMENT_CARD_URL_MAP[CardType.Unknown];

  if (walletIcon) return brandIsUnknown ? [walletIcon] : [walletIcon, brandIcon];

  return [getPaymentMethodIcon(method)];
};
